import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from './template/ScrollToTop';
import Home from './template/Home';
import About from './template/About';
import Package from './template/Package';
import PackageDetails from './template/PackageDetails';
import DestinationList from './template/DestinationList';
import LocationList from './template/LocationList';
import Activity from './template/Activity';
import ActivityDetails from './template/ActivityDetails';
import Blog from './template/Blog';
import BLogDetails from './template/BLogDetails';
import Hotel from './template/Hotel';
import Visa from './template/Visa';
import VisaDetails from './template/VisaDetails';
import Cruise from './template/Cruise';
import CruiseDetails from './template/CruiseDetails';
import ContactUs from './template/ContactUs';
import TermCondtions from './template/TermCondtions';
import PrivecyPolicy from './template/PrivecyPolicy';
import NotFound from './template/NotFound';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/package" element={<Package />} />
        <Route path="/tour-package/:slug" element={<PackageDetails />} />
        <Route path="/destination" element={<LocationList />} />
        <Route path="/destination/:slug" element={<DestinationList />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/activity/:slug" element={<ActivityDetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BLogDetails />} />
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/visa/:slug" element={<VisaDetails />} />
        <Route path="/cruise" element={<Cruise />} />
        <Route path="/cruise/:slug" element={<CruiseDetails />} />
        <Route path="/contact" element={<ContactUs />} />
         <Route path="/term-condition" element={<TermCondtions />} />
        <Route path="/Privecy-Policy" element={<PrivecyPolicy />} />
        <Route path="*" element={<NotFound />} />

          
      </Routes>

    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();